/**
 * Application entry point.
 * Bootstraps the React app into #root and loads self-hosted variable fonts
 * (Syne for display, Archivo for body) so no external requests are made (GDPR).
 */
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Fonts are now self-hosted in public/fonts/ and preloaded via index.html
// to break the critical request chain (HTML → CSS → font).

createRoot(document.getElementById("root")!).render(<App />);